var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('auth-tabs'),_vm._v(" "),_c('div',{staticClass:"sign-in__content-wrapper"},[_c('sign-in-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }